// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"28c2f293","70":"dd830f01","471":"c69bb4c1","757":"58ad8e04","949":"d28ae63a"}[chunkId] + ".chunk.css";
};